module.exports = __webpack_public_path__ + "static/media/phase three - 300px.a435af6d.png";